import api from "../../service/api";

export const getPrintList = async (practiceId) => {
    let path = null;
    path = `practice/hcfa-printers/?practice_id=${practiceId}`;
    return api.get(path);
}

export const addPrinterDetails = async (data) => {
    let path = null;
    path = "practice/hcfa-printers/";
    return api.post(path, data);
}

export const listHCFACoordinates = async (printerId,search) => {
    let path = null;
    path = `practice/hcfa-coordinates/?printer_id=${printerId}`;
    if (search){
        path += `&search=${search}`
    }
    return api.get(path);
}
export const singleHCFACoordinates = async (id) => {
    let path = null;
    path = `practice/hcfa-coordinates/${id}`;
    return api.get(path);
}

export const deletePrintList = async (id) => {
    let path = null;
    path = `practice/hcfa-printer-settings/${id}`
    return api.destroy(path);
}

export const updatePrintCoordinates = async(data) => {
    let path = "practice/hcfa-coordinates/update-inline/";
    return api.patch(path, data)
}
export const updateSingleHCFACoordinates = async(id,data) => {
    let path = `practice/hcfa-coordinates/${id}`;
    return api.patch(path, data)
}
export const getMargin = async (id) => {
    let path = null;
    path = `practice/hcfa-printer-margin/${id}`;
    return api.get(path);
}

export const updateMargin = async(id,data) => {
    let path = `practice/hcfa-printer-margin/${id}`;
    return api.patch(path, data)
}

export const getPrintSettings = async (id) => {
    let path = null;
    path = `practice/hcfa-printer-settings/${id}`;
    return api.get(path);
}

export const updatePrintSettings = async (id,data) => {
    let path = null;
    path = `practice/hcfa-printer-settings/${id}`;
    return api.patch(path, data);
}
